import { Item } from "../../typings/miro";


export function hasContentProp(
    widget: Item | undefined
): widget is Item & { content: string; } {
    if (!widget)
        return false;
    return "content" in widget;
}
